export default __webpack_public_path__ + "static/media/molka.baa9d30f.png";